// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__1Ev9K","lang":"Logo_lang__1-fbY"};